import request from '@/utils/request';

// 获取提现记录
export const commissionWithdrawalwithdrawalpageinit = (data: any): any =>
	request({
		url: '/pc/commissionWithdrawal/withdrawalpageinit',
		data: data
})
// 提现中心-审核否决
export const commissionWithdrawalcheckFail = (data: any): any =>
	request({
		url: '/pc/commissionWithdrawal/checkFail',
		data: data
})
// 提现中心-审核通过
export const commissionWithdrawalcheckSuccess = (data: any): any =>
	request({
		url: '/pc/commissionWithdrawal/checkSuccess',
		data: data
})
// 分销员购物金明细
export const commssioncommssionRecord = (data: any): any =>
	request({
		url: '/pc/commssion/commssionRecord',
		data: data
})
// 分销员购物金列表
export const commssionmemberCommission = (data: any): any =>
	request({
		url: '/pc/commssion/memberCommission',
		data: data
})


// 优惠券列表
export const activityCouponactivityCouponPageInit = (data: any): any =>
	request({
		url: '/pc/activityCoupon/activityCouponPageInit',
		data: data
})
// 优惠券删除
export const activitycouponactivityCouponDelete = (data: any): any =>
	request({
		url: '/pc/activitycoupon/activityCouponDelete',
		data: data
})
// 优惠券使失效
export const activitycouponactivityCouponLoseEfficacy = (data: any): any =>
	request({
		url: '/pc/activitycoupon/activityCouponLoseEfficacy',
		data: data
})
// 优惠券详情
export const activitycouponactivityCouponInfo = (data: any): any =>
	request({
		url: '/pc/activitycoupon/activityCouponInfo',
		data: data
})
// 优惠券保存
export const activitycouponactivityCouponSave = (data: any): any =>
	request({
		url: '/pc/activitycoupon/activityCouponSave',
		data: data
})
// 优惠券领取情况
export const activitycouponactivityCouponReceiveInfo = (data: any): any =>
	request({
		url: '/pc/activitycoupon/activityCouponReceiveInfo',
		data: data
})
// 优惠券批量发放记录
export const activitycouponsendMemberCouponImportRecord = (data: any): any =>
	request({
		url: '/pc/activitycoupon/sendMemberCouponImportRecord',
		data: data
})
// 批量发放
export const activitycouponsendMemberCouponImport = (data: any): any =>
	request({
		url: '/pc/activitycoupon/sendMemberCouponImport',
		data: data
})
//是否显示在领取页
export const activitycouponsetIsShowForReceivePage = (data: any): any =>
	request({
		url: '/pc/activitycoupon/setIsShowForReceivePage',
		data: data
})
export const sendMemberCouponList = (data: any): any =>
	request({
		url: '/pc/activitycoupon/sendMemberCouponList',
		data: data
})
export const activitycouponCancelByMember = (data: any): any =>
	request({
		url: '/pc/activitycoupon/cancelByMember',
		data: data
})
export const activitycouponCancelByCouponId = (data: any): any =>
	request({
		url: '/pc/activitycoupon/cancelByCouponId',
		data: data
})
export const activitycouponCancelMemberCouponImport = (data: any): any =>
	request({
		url: '/pc/activitycoupon/cancelMemberCouponImport',
		data: data
})
export const cancelMemberCouponImportResultExport = (data: any): any =>
	request({
		url: '/pc/activitycoupon/cancelMemberCouponImportResultExport',
		data: data
})



// 财务-合同发票
export const financecontractInvoice = (data: any): any =>
	request({
		url: '/pc/finance/contractInvoice',
		data: data
})
// 财务-发票管理
export const financeinvoiceManager = (data: any): any =>
	request({
		url: '/pc/finance/invoiceManager',
		data: data
})
// 财务-合同发票金额统计 
export const financecontractInvoiceStatistics = (data: any): any =>
	request({
		url: '/pc/finance/contractInvoiceStatistics',
		data: data
})
// 财务-上传发票
export const financeupLoadInvoice = (data: any): any =>
	request({
		url: '/pc/finance/upLoadInvoice',
		data: data
})
// 财务-合同发票
export const financechoseInvoiceInfo = (data: any): any =>
	request({
		url: '/pc/finance/choseInvoiceInfo',
		data: data
})
// 财务-服务合同发票开票
export const financeserviceContractInvoiceOpenInvoice = (data: any): any =>
	request({
		url: '/pc/finance/serviceContractInvoiceOpenInvoice',
		data: data
})
// 财务-购销合同确认收到发票
export const financebuyAndSellContractReceiveInvoice = (data: any): any =>
	request({
		url: '/pc/finance/buyAndSellContractReceiveInvoice',
		data: data
})


//获取会员详情
export const membermemberDetail = (data: any): any =>
	request({
		url: '/pc/member/memberDetail',
		data: data
})

//"购物金转移
export const commssionmemberCommissionTransfer = (data: any): any =>
	request({
		url: '/pc/commssion/memberCommissionTransfer',
		data: data
})

//财务-合同发票详情
export const financecontractInvoiceDetail = (data: any): any =>
	request({
		url: '/pc/finance/contractInvoiceDetail',
		data: data
})

//财务-合同发票服务合同发票删除
export const financedeleteServiceContractBill = (data: any): any =>
	request({
		url: '/pc/finance/deleteServiceContractBill',
		data: data
})


//优惠券转赠记录
export const activitycoupontransferRecord = (data: any): any =>
	request({
		url: '/pc/activitycoupon/transferRecord',
		data: data
})

//用户开票进度
export const orderInvoiceorderInvoiceList = (data: any): any =>
	request({
		url: '/pc/orderInvoice/orderInvoiceList',
		data: data
})
//用户开票进度详情
export const orderInvoiceorderInvoiceDetailList = (data: any): any =>
	request({
		url: '/pc/orderInvoice/orderInvoiceDetailList',
		data: data
})
